import template from './acc-overview.html';

class AccountOverviewPageVM
{
	constructor (page)
	{
		this.loaded = ko.observable(false);
		this.page = page;

		this.user = ko.observable(this.page.bindings.data);
		this.roles_str = ko.observable(this.user().user_roles.join(', '));
		this.email = ko.observable(this.user().email || '-');
		this.pg_role = ko.observableArray([]);
		this.selected_theme_mode = ko.observable('light');

		this.selected_theme_mode.subscribe(async (newVal) => {			
			if (newVal)
			{
				if( await Grape.themes.getMode() != newVal){

					await Grape.fetches.postJSON('/api/user-setting', {
						"setting_name": 'theme_mode',
						"value":`"${newVal}"`
					});				
					window.location.reload();
				}
			}	
		});
	}	
}

class AccountOverviewPage
{
	constructor (bindings)
	{
		this.bindings = bindings;
		this.viewModel = new AccountOverviewPageVM(this);
		this.timer = null;
	}

	async init ()
	{
		document.title = 'Account Overview';
		this.viewModel.selected_theme_mode(await Grape.themes.getMode());
	
	}

	async updateData ()
	{
		try 
		{
			let result = await fetch('/api/user/-1');
			let data = await result.json();

			if (result.ok)
			{
				this.viewModel.user(data.user);
				this.viewModel.roles_str(data.user.user_roles.join(', '));
				this.viewModel.email(data.user.email);
			}
			
		} catch (error) {
			Grape.alerts.alert({ type: 'error', title: 'Error', message: error.message });
			console.error(error);
		}	
	}

	new_password ()
	{
		Grape.dialog.open('NewPassword');
	}

	teardown ()
	{
		clearTimeout(this.timer);
	}
}

export default {
	route: '[/account/]acc-overview',
	page_id: 'overview',
	page_class: AccountOverviewPage,
	template: template
};